// @flow weak

import React from 'react';
import { defaultProps } from 'recompose';

import 'app/common/components/ErrorBlock.scss';

import type { HOC } from 'recompose';

type ErrorBlockProps = {
  errorMessage?: string,
  className?: string,
};

export const ErrorBlock = props => {
  return <p className="error-block">{props.errorMessage}</p>;
};

const defaultPropsValue = { errorMessage: 'Sorry, but there was an error.' };
const enhanceErrorBlock: HOC<*, ErrorBlockProps> = defaultProps(
  defaultPropsValue
);

export default enhanceErrorBlock(ErrorBlock);
